export const reviews = [
    {
        id: 1,
        author: 'Татьяна',
        date: '14.03.2026',
        text: 'Хожу сюда на аппаратный и классический массаж — очень нравится это место. Всегда уютная и спокойная атмосфера, всё чисто, красиво и продумано до мелочей. Персонал очень внимательный: всегда предложат чай, кофе, воду или батончики — мелочь, а очень приятно...',
        link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=yj5069z5pjg8jfx3v721pbw04r&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    },
    {
        id: 2,
        author: 'Елена',
        date: '28.03.2026',
        text: 'DI Massage - отличная студия! Приятная атмосфера, чисто и уютно, сразу чувствуется забота о клиенте. Мастера профессиональные и очень внимательные. Массаж делают качественно, после процедуры реально чувствуешь результат и ощущение лёгкости, тело заметно…',
        link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=kr36tfn0azm0687ytgm0zzfmv8&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    },
    {
        id: 3,
        author: 'Светлана',
        date: '24.02.2026',
        text: 'Хочу выразить огромную благодарность Дарье за волшебный расслабляющий массаж! Это был не просто сеанс, а настоящее спасение для моего тела и души. Дарья не только виртуозно проработала каждую уставшую мышцу, сняв напряжение, но и помогла полностью…',
        link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=ht0mbvr83q9ut0uj4hfdn126m8&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    },
    {
        id: 4,
        author: 'Софья',
        date: '26.06.2026',
        text: 'Замечательное место🌸✨Была в солярии - даже не заметила как пролетело время, благодаря музыке. Еще очень понравилась система увлажнения и обдува - по ощущениям, ты где-то на побережье…',
        link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=drgvebb9jp54rfuwj9bpg18twr&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    },
    {
        id: 5,
        author: 'Виолетта',
        date: '03.05.2026',
        text: 'Прошла курс аппаратного массажа в DL massage на аппарате r-sleek, помимо видимого результата (после 6 процедур уменьшились объемы, кожа стала ровнее и более подтянутой, уменьшился целлюлит), место очень приятное, стильное. Мне для полного расслабления важен также…',
        link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=4p3u1x7tu2jg9gmvrbm8mhb36m&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    },
    {
        id: 6,
        author: 'From',
        date: '25.02.2026',
        text: 'Спасение для уставших мышц и души! Хочу поделиться своими невероятными впечатлениями от посещения этого салона! 🙏 Я обратилась к Дарье с жалобами на боли в спине и…',
        link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=FromSochiWhLove&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    },
    {
        id: 7,
        author: 'Нарек',
        date: '01.04.2026',
        text: 'Огромное спасибо массажному салону и персонально массажисту Люде! Получил невероятное удовольствие от сеанса — всё идеально: атмосфера, техника, внимание к деталям. Чувствую себя заново родившейся! Обязательно вернусь снова',
        link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=hrtjfdmka79grf9tyy71554vg4&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    },
    {
        id: 8,
        author: 'Алина',
        date: '29.04.2026',
        text: 'Лучшее вложение в себя за последнее время! В студии очень душевная и располагающая обстановка, персонал внимательный и вежливый. Уже после первых процедур почувствовала легкость в теле, заметно уменьшились объемы и улучшилось самочувствие. Очень рада, что…',
        link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=1vv7h8gd0r5h1p623b4chvrbgc&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    },
    {
        id: 9,
        author: 'Мария',
        date: '01.04.2026',
        text: 'Людмила — профессионал своего дела. Очень долго искала специалиста, который делает мощно и грамотно. Пришла по рекомендации знакомого и, признаюсь, после посещения мастеров других салонов была удивлена. Людмила превзошла все мои ожидания. Отдельное спасибо за приятную…',
        link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=66q3cz31unbua6p7g07r871d6r&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    },
    // {
    //     id: 10,
    //     author: 'Марина',
    //     date: '30.04.2026',
    //     text: 'Очень довольна визитом. Понравились вежливые и внимательные сотрудники, которые готовы ответить на любые вопросы. После массажа появилось ощущение полного расслабления и прилив энергии. Боль в спине, которая беспокоила несколько дней, заметно уменьшилась.',
    //     link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=cezvg364fej480x76cezb0hxyg&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    // },
    // {
    //     id: 11,
    //     author: 'Сухов В.',
    //     date: '27.03.2026',
    //     text: 'Замечательный массаж! Дарья — мастер своего дела, очень вежливая и корректная. Качественная проработка мышц, после процедуры чувствую себя заново родившимся! . Чистый кабинет, приятная обстановка. Рекомендую всем!',
    //     link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=7y40ukz2nz290q3ncjqjx2njeg&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    // },
    // {
    //     id: 12,
    //     author: 'Мария',
    //     date: '02.03.2025',
    //     text: 'Отличный салон! Новый, очень эстетичный, удобное расположение. Есть ручной и аппаратный массаж, солярий! Удобно, что в одном месте! Супер специалисты, любимый специалист Люда, рекомендую сразу брать абонемент, дисциплинирует, и вау-эффект!',
    //     link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=brz90t5tep3jjxax8qg6gddzuc&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    // },
    // {
    //     id: 13,
    //     author: 'Марина',
    //     date: '02.11.2025',
    //     text: 'Очень рада, что нашла этот салон ) была у двух мастеров - оба (обе) профессионалы своего дела. То есть записываться можно на удобный вам день, а не к конкретному мастеру. Делаю аппаратный и антицеллютный массажи - жидкость выходит быстро - верю в результат. Осталось…',
    //     link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=uvznp2uu3y36p6u7a6u5rp1pcw&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    // },
    // {
    //     id: 14,
    //     author: 'Ирина',
    //     date: '12.05.2026',
    //     text: 'Очень, очень, очень Рекомендую, отличный салон, мастера профессионалы своего дела! Чисто, уютно, очень приятная атмосфера, отношение и внимание к клиентам на высшем уровне!! Результат от процедур 100%, чувствуешь с первого раза.',
    //     link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=n00gq4t2cq6n978hdcw4a4d7f8&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    // },
    // {
    //     id: 15,
    //     author: 'espresso',
    //     date: '18.04.2025',
    //     text: 'Нашла для себя место , которое давно искала , для того чтоб тело было в прекрасной форме! Превосходная хозяйка в одном лице с мастером , у которой золотые руки! Результат с первой процедуры! Спасибо Людмиле и Кристине ❤️',
    //     link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=w7mnctnf4hkdyjgaf9d7911b3w&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    // },
    // {
    //     id: 16,
    //     author: 'Елена',
    //     date: '01.09.2025',
    //     text: 'Отличные мастера, профессионалы своего дела! Отдельное спасибо мастеру Людмиле за индивидуальный подход, за стремление к результату , который не заставил себя ждать! Прошла курс аппаратного массажа, очень довольна. Студия очень атмосферная, уютная. Помимо массажа…',
    //     link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=g8vcwy5uzmw41nkdpnf03kha90&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    // },
    // {
    //     id: 17,
    //     author: 'Мария',
    //     date: '30.07.2026',
    //     text: 'Спасибо вашей студии, где я наконец нашла своего мастера! С которой мне очень комфортно, всегда интересуется моими ощущениями и делает потрясающий массаж! А еще в студии очень красиво, такое эстетичное пространство, куда хочется возвращаться )',
    //     link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=wjg75cbq0ceeg0f1gkf4mh5z94&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    // },
    // {
    //     id: 18,
    //     author: 'Виктория',
    //     date: '24.02.2026',
    //     text: 'Прихожу уже не первый раз, обычно к Дарье. Как говорится: Сначала больно , потом приятно. Массаж-это идеальное спасение и расслабление для таких тревожников как я.',
    //     link: 'https://yandex.ru/maps/org/159475417300/reviews?reviews%5BpublicId%5D=8mvete7dr136d2k0mvky9mj8m0&si=k32evmk1yeaet6a6xbaqru3u5r&utm_source=review',
    // },
]
